module.exports = __webpack_public_path__ + "static/img/12.908a675.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/12.png
// module id = 2jrG
// module chunks = 0